/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Grid } from '@mui/material';
import type { FC } from 'react';
import React from 'react';
import { defaultAnimationDelayAtStart } from '../../TimeSlider/timeSliderUtils';
import {
  AnimationLengthMode,
  AnimationLengthPanel,
} from '../AnimationLengthPanel';
import { SpeedButton } from '../SpeedButton/SpeedButton';
import { TimeSpanButton } from '../TimeSpanButton/TimeSpanButton';
import { TimeStepButton } from '../TimeStepButton/TimeStepButton';

export const OptionsMenu: FC<{
  timeSpanBtn?: React.ReactNode;
  timeStepBtn?: React.ReactNode;
  speedBtn?: React.ReactNode;
  animationLengthBtn?: React.ReactNode;
}> = ({ speedBtn, timeSpanBtn, timeStepBtn, animationLengthBtn }) => {
  return (
    <>
      <Grid size={{ xs: 'auto' }}>
        {animationLengthBtn || (
          <AnimationLengthPanel
            onChange={(): void => {}}
            setting={{ mode: AnimationLengthMode.Auto }}
          />
        )}
      </Grid>
      <Grid size={{ xs: 'auto' }}>
        {timeSpanBtn || (
          <TimeSpanButton
            disabled={false}
            isTimeSpanAuto={false}
            layerHasTimeStep={false}
            onChangeSliderValue={(): void => {}}
            onToggleTimeSpan={(): void => {}}
            timeSliderSpan={0}
          />
        )}
      </Grid>
      <Grid size={{ xs: 'auto' }}>
        {timeStepBtn || (
          <TimeStepButton
            isTimestepAuto={false}
            onChangeTimeStep={(): void => {}}
          />
        )}
      </Grid>
      <Grid size={{ xs: 'auto' }}>
        {speedBtn || (
          <SpeedButton
            animationDelay={defaultAnimationDelayAtStart}
            setMapAnimationDelay={(): void => {}}
          />
        )}
      </Grid>
    </>
  );
};
